import React, { createContext, useContext, useState, useEffect } from "react";
import { useAuth } from "react-oidc-context";
import ServicoAcolhimentoService from "../../main/services/ServicoAcolhimentoService";
import { criancaFunc } from "../../helpers/Funcionalidades";

const AppContext = createContext();

export const AuthProvider = ({ children }) => {
  const auth = useAuth();
  const [roleKeycloack, setRoleKeycloack] = useState([]);
  const [user, setUser] = useState({});

  useEffect(() => {
    const parseToken = async () => {
      if (auth?.user?.access_token) {
        try {
          const base64Url = auth.user.access_token.split(".")[1];
          const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
          const jsonPayload = decodeURIComponent(
            atob(base64)
              .split("")
              .map((c) => {
                return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
              })
              .join("")
          );

          const parsedPayload = JSON.parse(jsonPayload);
          const parsedKeyCloack = parsedPayload.resource_access?.mca?.roles;

          if (parsedKeyCloack.includes(criancaFunc.visualizarTudoTutelar)) {
            const res = await ServicoAcolhimentoService.getOrgaoExternoConselho(
              parsedPayload?.orgaoExterno[0]
            );
            const map = res.data.map((value) => value.id);
            setUser({
              ...parsedPayload,
              orgaoExterno: map,
              orgaoExternoOriginal: parsedPayload.orgaoExterno
                ? [parsedPayload?.orgaoExterno[0]]
                : [],
            });
          } else {
            setUser({
              ...parsedPayload,
              orgaoExternoOriginal: parsedPayload.orgaoExterno
                ? [parsedPayload?.orgaoExterno[0]]
                : [],
            });
          }

          setRoleKeycloack(parsedKeyCloack);
        } catch (error) {
          console.error("Failed to parse JWT token", error);
        }
      }
    };

    parseToken();
  }, [auth?.user?.access_token]);

  const contextValue = {
    roleKeycloack,
    user,
  };

  return (
    <AppContext.Provider value={contextValue}>{children}</AppContext.Provider>
  );
};

export const useAuthProvider = () => useContext(AppContext);
